/**
 * Single source of truth for version strings shown in the playground UI
 * (statusbar, terminal, About page). The playground and its bundled
 * interpreter share one version — keep PLAYGROUND_VERSION in sync with
 * frontend/package.json and interpreter/package.json.
 */
export const XCX_LANGUAGE_VERSION = '4.4';
export const PLAYGROUND_VERSION = '2.2.0';
export const BUILD_DATE = 'September 2026';
